export default function ctaWithIconInit() {
  const offerDetails = document.querySelectorAll(".js-cta-with-icon");

  offerDetails.forEach((offerDetail) => {
    offerDetail.addEventListener("click", () => {
      const spanElement = offerDetail.querySelector("span");
      const iconElement = offerDetail.querySelector(".icon");
      const useElement = iconElement.querySelector("use");
      const currentHref = useElement.getAttribute("xlink:href");
            
      /* Toggle the icon class */
      iconElement.classList.toggle("icon--plus");
      iconElement.classList.toggle("icon--minus");

      /* Toggle the xlink:href attribute */
      if (currentHref === "/assets/media/icons/symbol-defs.svg#icon-minus") {
        useElement.setAttribute("xlink:href", "/assets/media/icons/symbol-defs.svg#icon-plus");
        spanElement.textContent = spanElement.dataset.buttonMoreText;
      } else {
        useElement.setAttribute("xlink:href", "/assets/media/icons/symbol-defs.svg#icon-minus");
        spanElement.textContent = spanElement.dataset.buttonLessText;
      }
    });
  });
}
